import { memo } from 'react';

import { CheckoutConfirmationResponseType } from 'src/models/Checkout/Confirmation';
import { useTHelper } from 'src/utils/i18n';
import { CheckoutConfirmationTable } from 'src/pages/Checkout/components/common/Table';

type Props = {
  model:
    | CheckoutConfirmationResponseType['ChargedNowPaymentSubsection']
    | CheckoutConfirmationResponseType['BidPaymentSubsection']
    | CheckoutConfirmationResponseType['PledgePaymentSubsection'];
};

export const CheckoutConfirmationPaymentsSummary = memo<Props>(({ model }) => {
  const tHelper = useTHelper('checkout.confirmation.paymentsSummary');

  const columns = [
    { name: model.PaymentTerm, className: 'left' },
    { name: tHelper('amount'), className: 'right' },
  ];

  return (
    <CheckoutConfirmationTable columns={columns} data={model.Lines}>
      {(item) => (
        <>
          <td className="left">{item.Title}</td>
          <td className="right">{item.Value}</td>
        </>
      )}
    </CheckoutConfirmationTable>
  );
});
